
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vijesti/vijest",
      function () {
        return require("private-next-pages/vijesti/vijest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vijesti/vijest"])
      });
    }
  